import React from "react";
import { Trash2, Plus } from "lucide-react";

// Fallback image in case the database link is broken
const fallbackImg = "https://cdn-icons-png.flaticon.com/512/2662/2662503.png";

function ShoppingList({
  currentCombination,
  selectedItem,
  setSelectedItem,
  budget,
  onRemoveItem,
  onOpenAddModal,
  onSave,
}) {
  // Handle empty state
  if (!currentCombination || currentCombination.length === 0) {
    return (
      <div className="bg-[#F5E6D3]/40 border border-[#E8D1B7] p-6 rounded-2xl shadow-sm">
        <p className="text-[#6F5A42] text-center opacity-70">
          No items selected yet.
        </p>
      </div>
    );
  }

  // Calculate total
  const totalCost = currentCombination.reduce(
    (sum, item) => sum + (item.price || 0),
    0
  );

  return (
    <div className="bg-[#F5E6D3]/40 border border-[#E8D1B7] p-6 rounded-2xl shadow-sm">
      {/* Budget summary */}
      <div className="flex justify-between items-end mb-4 border-b border-[#E8D1B7] pb-4">
        <div>
           <p className="text-[#6F5A42]">
            Budget:{" "}
            <span className="font-bold text-[#38A3A5]">
              RM {budget || 0}
            </span>
          </p>
          <p className="text-[#6F5A42]">
            Total:{" "}
            <span
              className={`font-bold ${
                totalCost > budget ? "text-red-500" : "text-[#38A3A5]"
              }`}
            >
              RM {totalCost.toFixed(2)}
            </span>
          </p>
        </div>
        <div className="text-right">
             <span className="text-xs text-[#6F5A42] opacity-70">Items: {currentCombination.length}</span>
        </div>
      </div>

      {/* Item list */}
      <div className="space-y-4">
        {currentCombination.map((item, index) => {
          // Check if this specific item is selected
          const isSelected = selectedItem?.name === item.name && selectedItem?.price === item.price;

          return (
            <div
              key={index}
              onClick={() => setSelectedItem(item)}
              className={`flex items-center gap-4 p-3 rounded-xl border shadow-sm cursor-pointer transition
                ${
                  isSelected
                    ? "bg-[#E8FFF8] border-[#38A3A5] ring-1 ring-[#38A3A5]"
                    : "bg-[#FFF7E6] border-[#E8D1B7] hover:bg-[#FFF0D9]"
                }
              `}
            >
              {/* ✅ REAL IMAGE LOGIC */}
              <div className="w-16 h-16 bg-white rounded-lg border border-[#FFE1B4] p-1 flex-shrink-0">
                <img
                  src={item.image_url || fallbackImg} 
                  alt={item.name}
                  className="w-full h-full object-contain"
                  onError={(e) => { e.target.src = fallbackImg; }}
                />
              </div>

              <div className="flex-1 min-w-0"> {/* min-w-0 fixes text truncation issues */}
                <h3 className="font-bold text-[#5A3E2B] text-sm leading-tight truncate">
                  {item.name || item.product_name}
                </h3>

                <p className="text-sm font-semibold text-[#38A3A5]">
                  RM {item.price?.toFixed(2)}
                </p>

                <div className="flex gap-2 text-xs text-[#6F5A42] opacity-80 mt-1">
                  <span className="bg-[#FFE4C4] px-2 py-0.5 rounded text-[10px] truncate max-w-[80px]">
                    {item.store}
                  </span>
                  <span className="truncate max-w-[100px]">
                   {item.category}
                  </span>
                </div>
              </div>

              <button
                onClick={(e) => {
                  e.stopPropagation(); // prevent select on delete
                  onRemoveItem(index);
                }}
                className="text-red-400 hover:text-red-600 p-2 hover:bg-red-50 rounded-full transition"
              >
                <Trash2 size={18} />
              </button>
            </div>
          );
        })}
      </div>

      {/* Action buttons */}
      <div className="flex justify-between mt-6 pt-4 border-t border-[#E8D1B7]">
        <button
          onClick={onOpenAddModal}
          className="flex items-center gap-2 bg-[#FFB67A] text-[#5A3E2B] px-4 py-2 rounded-xl hover:bg-[#FFC28F] transition font-semibold text-sm"
        >
          <Plus size={18} /> Add Item
        </button>

        <button
          onClick={onSave}
          className="bg-[#1C768F] text-white px-6 py-2 rounded-xl hover:bg-[#176079] transition font-semibold text-sm shadow-md"
        >
          Save List
        </button>
      </div>
    </div>
  );
}

export default ShoppingList;